import _regeneratorRuntime from "/runner/_work/developers/developers/node_modules/@babel/runtime/regenerator/index.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
export var trackPage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function (_ref2) {
    var tracker = _ref2.tracker,
      page = _ref2.page,
      name = _ref2.name,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return tracker.trackPage(page, name, _objectSpread({
              diffTollerancePercent: 1,
              screenshotOptions: _objectSpread({
                fullPage: true,
                animations: 'disabled'
              }, options === null || options === void 0 ? void 0 : options.screenshotOptions)
            }, options));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })();
  });
  return function trackPage(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var isVRT = Boolean(process.env.VRT);